import { EventEmitter, Component, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Contexto } from '../../../../../models/contexto';
import { NodeType } from '../../../models/node-type';
import { NodoArbolMenu } from '../../../models/nodo-arbol-menu';
import { PopupService } from '../../../../../services/popup.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmarAbrirVentanaDialogComponent } from '../confirmar-abrir-ventana-dialog/confirmar-abrir-ventana-dialog.component';
import { ContextoUrlService } from '../../../../../services/contexto-url.service';
import { NavigationContextService } from '../../../../../services/navigation-context.service';

@Component({
  selector: 'app-nodo-arbol',
  templateUrl: './nodo-arbol.component.html',
  styleUrls: ['./nodo-arbol.component.scss']
})

export class NodoArbolComponent implements OnInit {

  @Input() public ctx: Contexto;
  @Output() nodeEmitter: EventEmitter<string>;
  @Output() renderMenuArbolEmitter: EventEmitter<Object>;
  @Output() displayAnswerEmitter: EventEmitter<NodoArbolMenu>;
  @Output() displayTramiteEmitter: EventEmitter<NodoArbolMenu>;
  @Output() displayEnlaceEmitter: EventEmitter<NodoArbolMenu>;
  @Input("node") node: NodoArbolMenu;
  @Input() esFaq: boolean = false;
  @Input("cantidadNodos") cantidadNodos: number;
  @Input("numberOfSiblingsArr") numberOfSiblingsArr: number[];
  @Input("numberOfSiblingsArrCreation") numberOfSiblingsArrCreation: number[];
  @Input() requiereAutenticacion: boolean;

  displayAnswer: boolean; //mostrar la respuesta si el nodo es de tipo respuesta y el usuario clickea en el nodo
  NodeType: any = NodeType;

  constructor(private router: Router, 
    private popupService: PopupService, 
    private contextoService: ContextoUrlService, 
    private navigationContextService: NavigationContextService,
    private readonly dialog: MatDialog) {
    this.displayAnswer = false;
    this.nodeEmitter = new EventEmitter<string>();
    this.displayAnswerEmitter = new EventEmitter<NodoArbolMenu>();
    this.displayTramiteEmitter = new EventEmitter<NodoArbolMenu>();
    this.displayTramiteEmitter = new EventEmitter<NodoArbolMenu>();
    this.renderMenuArbolEmitter = new EventEmitter<Object>();
  }

  ngOnInit() {
  }

  abrirVentanaCentrada(nodo) {
    if (nodo) {
      let urlUrlSitio = this.ctx.urlSitioAutenticar;
      if (!urlUrlSitio.endsWith('/')) {
        urlUrlSitio = urlUrlSitio + '/';
      }
      
      urlUrlSitio = urlUrlSitio + '/?idNodo=' + nodo.id + '&open=true&hideAllButtonsForm=true&goInside=true&fromAnonymous=true';
      if (this.ctx.idServicio) {
        urlUrlSitio = urlUrlSitio + "&idServicio=" + this.ctx.idServicio;
      }
      this.navigationContextService.addNode(nodo.id);
      const ids = this.navigationContextService.getIds();
      if(ids && ids.length > 0) {
        urlUrlSitio = urlUrlSitio + "&ids=" + this.navigationContextService.getIds();
      }
      urlUrlSitio = urlUrlSitio + "&contexto=" + this.contextoService.encode(this.contextoService.getParentUrlSafely());
      this.popupService.abrirVentana(urlUrlSitio, "Alisse", 600, 750);
    }
  }

  selectNode() {
    //this.ctx.esEntornoAnonimo=true;
    switch (this.node.type) {
      case NodeType.Action: {
        if (this.ctx.esEntornoAnonimo && this.node.requiereAutenticacion) {
          this.abrirVentanaCentrada(this.node);
        } else {
          this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.node.assistanceId, nodo: this.node, tipo: NodeType.Action })
        }
        break;
      }
      case NodeType.Chat: {
        if (this.ctx.esEntornoAnonimo && this.node.requiereAutenticacion) {
          this.abrirVentanaCentrada(this.node);
        } else {
          this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.node, tipo: NodeType.Chat })
        }
        break;
      }
      case NodeType.Form: {
        this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.node, tipo: NodeType.Form })
        break;
      }
      case NodeType.Question: {
        this.nodeEmitter.emit(this.node.id.toString());
        break;
      }
      case NodeType.Response: {
        this.displayAnswerEmitter.emit(this.node)
        break;
      }
      case NodeType.FAQ: {
        this.displayAnswerEmitter.emit(this.node)
        break;
      }
      case NodeType.Tramite: {
        this.displayTramiteEmitter.emit(this.node)
        break;
        //this.renderMenuArbolEmitter.emit({ idServicio: this.ctx.idServicio, codAsistente: this.ctx.codAsistente, nodo: this.node, tipo:NodeType.Tramite })
        //break;
      }
      case NodeType.Enlace: {
        // this.displayEnlaceEmitter.emit(this.node);
        if (this.node.url) {
          window.open(this.node.url, '_blank');
        } else {
          console.warn('Nodo tipo Enlace sin URL:', this.node);
        }
        break;
      }

    }
  }

}
